import { LoadingStatusType, SalarySelectedDateOptionType, SalarySummaryType } from "@/enums/enums";
import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import service from "@/service/Index";

@Module({ namespaced: true })
export default class DashBoard extends VuexModule {
  public chartDepartment: any = null;
  public chartDepartmentLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public chartPosition: any = null;
  public chartPositionLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public chartRevenueDeduct: any = null;
  public chartRevenueDeductLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public salarySummaryLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public salarySummary: any = null;
  public chartAccount: any = null;
  public chartAccountLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public UpdateIsRecommend: any = null;
  private RecommendLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private Recommend: any = null;
  private UpdateIsRecommendLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getChartDepartment() {
    return this.chartDepartment;
  }
  get getChartDepartmentLoadingStatus() {
    return this.chartDepartmentLoadingStatus;
  }
  get getChartPosition() {
    return this.chartPosition;
  }
  get getChartPositionLoadingStatus() {
    return this.chartPositionLoadingStatus;
  }
  get getChartRevenueDeduct() {
    return this.chartRevenueDeduct;
  }
  get getChartRevenueDeductLoadingStatus() {
    return this.chartRevenueDeductLoadingStatus;
  }
  get getSalarySummaryLoadingStatus() {
    return this.salarySummaryLoadingStatus;
  }
  get getSalarySummary() {
    return this.salarySummary;
  }
  get getChartAccount() {
    return this.chartAccount;
  }
  get getChartAccountLoadingStatus() {
    return this.chartAccountLoadingStatus;
  }
  get getRecommend() {
    return this.Recommend;
  }
  get getRecommendLoadingStatus() {
    return this.RecommendLoadingStatus;
  }
  get getUpdateIsRecommendLoadingStatus() {
    return this.UpdateIsRecommendLoadingStatus;
  }
  @Mutation
  public MutationSetChartDepartment(chart: any) {
    this.chartDepartment = chart;
  }

  @Mutation
  public MutationSetChartDepartmentLoadingStatus(status: LoadingStatusType) {
    this.chartDepartmentLoadingStatus = status;
  }

  @Mutation
  public MutationSetChartPosition(chart: any) {
    this.chartPosition = chart;
  }

  @Mutation
  public MutationSetChartPositionLoadingStatus(status: LoadingStatusType) {
    this.chartPositionLoadingStatus = status;
  }

  @Mutation
  public MutationSetChartRevenueDeduct(chart: any) {
    this.chartRevenueDeduct = chart;
  }

  @Mutation
  public MutationSetChartRevenueDeductLoadingStatus(status: LoadingStatusType) {
    this.chartRevenueDeductLoadingStatus = status;
  }
  @Mutation
  public MutationSetSalarySummaryLoadingStatus(status: LoadingStatusType) {
    this.salarySummaryLoadingStatus = status;
  }
  @Mutation
  public MutationSetSalarySummary(summary: any) {
    this.salarySummary = summary;
  }
  @Mutation
  public MutationSetChartAccount(chart: any) {
    this.chartAccount = chart;
  }
  @Mutation
  public MutationSetChartAccountLoadingStatus(status: LoadingStatusType) {
    this.chartAccountLoadingStatus = status;
  }
  @Mutation
  public MutationUpdateIsRecommend(status: LoadingStatusType) {
    this.UpdateIsRecommend = status;
  }
  @Mutation
  public MutationSetRecommend(Recommend: any) {
    this.Recommend = Recommend;
  }
  @Mutation
  public MutationSetRecommendLoadingStatus(status: LoadingStatusType) {
    this.RecommendLoadingStatus = status;
  }
  @Mutation
  public MutationUpdateIsRecommendLoadingStatus(status: LoadingStatusType) {
    this.UpdateIsRecommendLoadingStatus = status;
  }

  @Action
  public DoGetChartDepartment(selectedDateOptionType: SalarySelectedDateOptionType) {
    if (this.chartDepartmentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetChartDepartmentLoadingStatus", LoadingStatusType.Loading);
      service.DashBoardService.DoGetChartDepartment(selectedDateOptionType).then((res) => {
        if (res.status.IsSuccess()) {
          this.context.commit("MutationSetChartDepartment", res.data.chart);
        }
        this.context.commit("MutationSetChartDepartmentLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetChartPosition(selectedDateOptionType: SalarySelectedDateOptionType) {
    if (this.chartPositionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetChartPositionLoadingStatus", LoadingStatusType.Loading);
      service.DashBoardService.DoGetChartPosition(selectedDateOptionType).then((res) => {
        if (res.status.IsSuccess()) {
          this.context.commit("MutationSetChartPosition", res.data.chart);
        }
        this.context.commit("MutationSetChartPositionLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetChartRevenueDeduct(selectedDateOptionType: SalarySelectedDateOptionType) {
    if (this.chartRevenueDeductLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetChartRevenueDeductLoadingStatus", LoadingStatusType.Loading);
      service.DashBoardService.DoGetChartRevenueDeduct(selectedDateOptionType).then((res) => {
        if (res.status.IsSuccess()) {
          this.context.commit("MutationSetChartRevenueDeduct", res.data.chart);
        }
        this.context.commit("MutationSetChartRevenueDeductLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetSalarySummary(input: any) {
    if (this.chartRevenueDeductLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetSalarySummaryLoadingStatus", LoadingStatusType.Loading);
      service.DashBoardService.DoGetSalarySummary(input).then((res) => {
        if (res.status.IsSuccess()) {
          this.context.commit("MutationSetSalarySummary", res.data.summary);
        }
        this.context.commit("MutationSetSalarySummaryLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetChartAccount(selectedDateOptionType: SalarySelectedDateOptionType) {
    if (this.chartAccountLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetChartAccountLoadingStatus", LoadingStatusType.Loading);
      service.DashBoardService.DoGetChartAccount(selectedDateOptionType).then((res) => {
        if (res.status.IsSuccess()) {
          this.context.commit("MutationSetChartAccount", res.data.chart);
        }
        this.context.commit("MutationSetChartAccountLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoUpdateIntroduce() {
    if (this.UpdateIsRecommendLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationUpdateIsRecommendLoadingStatus", LoadingStatusType.Loading);
      service.DashBoardService.DoUpdateIntroduce().then((result: any) => {
        this.context.commit("MutationUpdateIsRecommendLoadingStatus", LoadingStatusType.Success);
        this.context.commit("MutationSetRecommendLoadingStatus", LoadingStatusType.None);
      });
    }
  }
  @Action
  public DoGetIntroduce() {
    if (this.RecommendLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetRecommendLoadingStatus", LoadingStatusType.Loading);
      service.DashBoardService.DoGetIntroduce().then((res) => {
        if (res.status.IsSuccess()) {
          const detail = res.data.recommendModel ? res.data.recommendModel.recommendIntroduceModel : false;
          this.context.commit("MutationSetRecommend", detail);
        }
        this.context.commit("MutationSetRecommendLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
}
